export default "__VITE_ASSET__voEn4_07__"